import {
  FleetTireSetEditFormValues,
  FleetTireSetDetailFormValues,
  FleetTireSetSearchFormValues,
  FleetTireDetailFormValues,
  FleetTireSearchFormValues,
  FleetTireAddFormValues,
  FleetTireSetReplacementFormValues,
  FleetTireSetDocumentEditFormValues,
  FleetTireSetTransferFormValues,
  FleetTireSetWriteOffFormValues,
} from "./types";

export const FLEET_TIRE_SET_DISPOSAL_DOCUMENT_TYPE_ID = "O";

export const initialFleetTireSetWriteOffForm: FleetTireSetWriteOffFormValues = {
  ecologicallyDisposed: true,
  writeOffDate: new Date(),
  uploads: [],
};



/*-------------------------------------------------------------------------------------------
  TIRE SET EDIT
---------------------------------------------------------------------------------------------*/

export const initialFleetTireSetEditForm: FleetTireSetEditFormValues = {
  id: null,
  code: null,
  isActive: false,
  tires: [],
  vehicle: null,
  warehouse: null,
  tireSetReplacement: null,
};

export const initialFleetTireSetReplacementForm: FleetTireSetReplacementFormValues = {
  tireSetId: null,
  warehouseId: null,
  replacementDate: null,
}

/*-------------------------------------------------------------------------------------------
  TIRE SET SEARCH
---------------------------------------------------------------------------------------------*/
export const initialFleetTireSetSearchForm: FleetTireSetSearchFormValues = {
  search: "",
  width: null,
  height: null,
  radius: null,
  vehicleManufacturerId: null,
  vehicleModelId: null,
  vehicleTypeId: null,
  warehouseId: null,
  tireManufacturerId: null,
  tireTypeId: null,
  dot: null,
  profileDepth: null,
  advancedSearch: [],
};

/*-------------------------------------------------------------------------------------------
  TIRE SET DETAILS
---------------------------------------------------------------------------------------------*/

export const initialFleetTireSetDetailForm: FleetTireSetDetailFormValues = {
  id: null,
  dimension: [],
  tireType: null,
  location: null,
  tires: [],
};

/*-------------------------------------------------------------------------------------------
  TIRE SET DOCUMENTS
---------------------------------------------------------------------------------------------*/

export const initialFleetTireSetDocumentEditForm: FleetTireSetDocumentEditFormValues =
  {
    name: null,
    description: null,
    documentTypeId: null,
    files: []
  };


/*-------------------------------------------------------------------------------------------
  TIRE DETAILS
---------------------------------------------------------------------------------------------*/

export const initialFleetTireDetailForm: FleetTireDetailFormValues = {
  id: null,
};

/*-------------------------------------------------------------------------------------------
  TIRE SET SEARCH
---------------------------------------------------------------------------------------------*/
export const initialFleetTireSearchForm: FleetTireSearchFormValues = {
  search: "",
  width: null,
  height: null,
  radius: null,
  vehicleManufacturerId: null,
  vehicleModelId: null,
  vehicleTypeId: null,
  warehouseId: null,
  dot: null,
  profileDepth: null,
  advancedSearch: [],
};

/*-------------------------------------------------------------------------------------------
  TIRE ADD
---------------------------------------------------------------------------------------------*/

export const initialFleetTireAddFormValues: FleetTireAddFormValues = {
  id: null,
  width: null,
  height: null,
  radius: null,
  quantity: 4,
  dot: 0,
  profileDepth: 0,
  rof: false,
  tireManufacturerId: null,
  tireTypeId: null,
  vehicleId: null,
  axlePosition: null,
};

/*-------------------------------------------------------------------------------------------
  TIRE SET TRANSFER
---------------------------------------------------------------------------------------------*/

export const initialFleetTireSetTransferForm: FleetTireSetTransferFormValues = {
  transferType: null,
  targetWarehouseId: null,
  targetVehicleId: null,
  transferDate: new Date(),
  newTireSetId: null,
  oldSetWarehouseId: null,
};